'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleTextStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  expanded: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  expanded: false,
  autoCollapsing: false
};

var collapsing = function collapsing(_ref) {
  var themeFromProvider = _ref.theme,
      expanded = _ref.expanded,
      autoCollapsing = _ref.autoCollapsing;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint;
  var collapsedStyles = '\n    position: fixed;\n    opacity: 0;\n    pointer-events: none;\n  ';
  var expandedStyles = '\n    position: relative;\n    opacity: 1;\n    pointer-events: initial;\n  ';

  if (autoCollapsing) {
    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
  } else {
    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
  }
};
/** Styles */


var ToggleTextStyled = exports.ToggleTextStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ToggleTextStyled'
})(['flex-grow:1;word-break:break-word;', ' ', ';'], collapsing, (0, _reactackleCore.transition)('opacity'));

ToggleTextStyled.propTypes = propTypes;
ToggleTextStyled.defaultProps = defaultProps;
ToggleTextStyled.displayName = 'ToggleTextStyled';